import { ErrorKey } from '../app-active-error/ErrorKey';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { setupAuthForNewPortal } from '../store/auth/action-creators';
import { setError } from '../store/error/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { getParsedErrorData } from '../store/signup-data-validation/utils/parseErrorData';
import { getLoginStatusFromResponse } from '../auth/authUtils';
const LOG = Logger.getLogger('handleLoginNewPortalResponse');
export const handleLoginNewPortalSuccess = (response, dispatch) => {
  LOG.info('login-new-portal-success', {
    extra: response
  });
  dispatch(Tracker.signupInteraction('login-new-portal-success', {
    message: getLoginStatusFromResponse(response)
  }));
  return dispatch(setupAuthForNewPortal());
};
export const handleLoginNewPortalFailure = (error, dispatch) => {
  const {
    status,
    message
  } = error || {};
  const {
    dataMessage,
    dataStatus
  } = getParsedErrorData(error);
  dispatch(Tracker.signupInteraction('login-new-portal-error', {
    errorType: dataStatus,
    errorCode: status,
    message: dataMessage,
    currentValue: message
  }));
  LOG.error(`attemptUserLogin-cookie: ${status || 'no-status'}`, {
    extra: getSentryExtra(error)
  });
  dispatch(setError(ErrorKey.LoginFailed, error));
};